module.exports = __webpack_public_path__ + "img/download.da2a399d.jpg";